import React, { useEffect } from 'react'
import { Range, getTrackBackground } from 'react-range'

const STEP = 1
const MIN = 18
const MAX = 100

const RangeInput = ({
  onChange,
  value,
  rtl = false,
  min = MIN,
  max = MAX,
  step = STEP,
}) => {
  const numbers = value.map((n) => parseInt(n))
  const from = Math.max(Math.min(...numbers), min)
  const to = Math.max(Math.max(...numbers), min)

  const [values, setValues] = React.useState([
    Math.max(min, from),
    Math.max(min, to),
  ])

  useEffect(() => {
    setValues([from, to])
  }, [from, to])

  return (
    <div className="inline-block flex justify-center items-center w-full">
      <output className="whitespace-nowrap text-inherit text-sm font-medium">
        {parseFloat(values[0]).toFixed(0)} - {parseFloat(values[1]).toFixed(0)}{' '}
        y/o
      </output>

      <Range
        allowOverlap
        draggableTrack
        values={values}
        onFinalChange={onChange}
        step={STEP}
        min={min}
        max={max}
        onChange={setValues}
        renderTrack={({ props, children }) => (
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            style={props.style}
            className="flex w-full min-w-[8rem] px-4 h-6"
          >
            <div
              ref={props.ref}
              style={{
                height: '5px',
                width: '100%',
                borderRadius: '4px',
                background: getTrackBackground({
                  values,
                  colors: ['#ccc', '#326295', '#ccc'],
                  min,
                  max,
                  rtl,
                }),
                alignSelf: 'center',
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props, isDragged }) => (
          <div
            {...props}
            style={props.style}
            className="h-4 w-4 rounded-full bg-blue-400 flex justify-center items-center shadow"
          >
            <div
              className={`${
                isDragged ? 'bg-primary-darker' : 'bg-primary'
              } h-4 w-4 rounded-full inline-block`}
            />
          </div>
        )}
      />
    </div>
  )
}

export default RangeInput
